import(/* webpackMode: "eager", webpackExports: ["DeveloperPageClient"] */ "/vercel/path0/components/developer/DeveloperPageClient.tsx");
